<template>
  <a @click="triggerAction">
    <slot name="trigger">
      <a class="mr-2">
        <MIcon name="user-plus" />
      </a>
    </slot>
    <FlotoDrawerForm
      :open="isDrawerOpen"
      width="50%"
      @cancel="handleDrawer"
      @hide="handleDrawer"
      @submit="handleSubmit"
    >
      <template v-slot:header>
        {{ item.name }}
      </template>
      <div class="mx-3">
        <DelegateApprovalForm
          v-model="delegateApprovalFormData"
          :resource-id="item.id"
        />
      </div>

      <template v-slot:actions="{ submit, hide }">
        <MButton
          id="submit-btn"
          class="mx-1"
          variant="primary"
          :loading="processing"
          @click="submit"
        >
          {{ $tc('update') }}
        </MButton>

        <MButton id="cancel-btn" class="mx-1" variant="default" @click="hide">
          {{ $tc('cancel') }}
        </MButton>
      </template>
    </FlotoDrawerForm>
  </a>
</template>

<script>
import DelegateApprovalForm from '@components/layout/profile/delegate-approval-form'
import { updateDelegateApprovalApi } from '@components/layout/profile/api'
export default {
  name: 'DelegateApprovalDrawer',
  components: { DelegateApprovalForm },
  props: {
    item: { type: Object, default: undefined },
  },
  data() {
    return {
      loading: true,
      isDrawerOpen: false,
      processing: false,
      delegateApprovalFormData: {},
    }
  },
  methods: {
    handleDrawer() {
      this.isDrawerOpen = false
    },
    triggerAction() {
      this.$emit('trigger')
      setTimeout(() => {
        this.isDrawerOpen = true
      }, 100)
    },
    handleSubmit() {
      this.processing = true
      updateDelegateApprovalApi(this.item.id, this.delegateApprovalFormData)
        .then((data) => {
          this.delegateApprovalFormData = data
        })
        .finally(() => {
          this.processing = false
          this.isDrawerOpen = false
        })
    },
  },
}
</script>
